<template>
  <v-container fluid class="invoice-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab  :href="`#tab-invoice`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Invoice
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-invoice'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Invoice</p>
                      <v-select
                        :readonly="isNotEditable"                          
                        class="mb-4"
                        :items="invoicetype[type]"
                        v-on:change="onChangeInvoice($event, 'invoicetype')"
                        v-bind:error="errorindex == 0"
                        v-bind:value="initvalue.invoicetype"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the invoice type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_invoicedate"
                        v-model="menu_invoicedate"
                        :close-on-content-click="false"
                        :return-value.sync="invoicedate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="invoicedate"
                            label="Invoice Date"
                            v-bind="attrs"
                            v-bind:value="invoicedate"
                            v-on:change="
                              onChangeInvoice($event, 'invoicedate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the invoice date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="invoicedate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_invoicedate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeInvoice(
                                invoicedate,
                                'invoicedate'
                              );
                              $refs.menu_invoicedate.save(invoicedate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_invoiceduedate"
                        v-model="menu_invoiceduedate"
                        :close-on-content-click="false"
                        :return-value.sync="invoiceduedate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="invoiceduedate"
                            label="Invoice Due Date"
                            v-bind="attrs"
                            v-bind:value="invoiceduedate"
                            v-on:change="
                              onChangeInvoice($event, 'invoiceduedate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the invoice due date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="invoiceduedate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_invoiceduedate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeInvoice(
                                invoiceduedate,
                                'invoiceduedate'
                              );
                              $refs.menu_invoiceduedate.save(invoiceduedate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Sent', 'Partial', 'Completed']"
                        v-bind:value="initvalue.invoicestatus"
                        v-on:change="onChangeInvoice($event, 'invoicestatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        append-icon="mdi-magnify"
                        :placeholder="`${type=='rental' ? 'Tenant' : 'Customer'} Name`"
                        single-line 
                        :hint="`Select ${type=='rental' ? 'Tenant' : 'Customer'} Name`"
                        outlined
                        dense
                        @click:append="searchCustomerDialog"
                        v-on:change="
                          onChangeInvoice($event, 'invoicename')
                        "
                        persistent-hint
                        v-bind:value="initvalue.invoicename"
                        v-bind:error="errorindex == 3"
                      >
                      </v-text-field>  
                      <v-textarea
                        :readonly="isNotEditable"
                        outlined
                        v-bind:value="initvalue.invoiceaddress"
                        v-on:change="
                          onChangeInvoice($event, 'invoiceaddress')
                        "
                        rows="2"
                        label="Address"
                        hint="please enter the customer address"
                      ></v-textarea>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-bind:value="initvalue.invoicephone"
                        v-on:change="
                          onChangeInvoice($event, 'invoicephone')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Phone"
                        persistent-hint
                        single-line
                        hint="Enter the phone"
                      >
                      </v-text-field>

                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        v-if="type=='service'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'THB']"
                        v-model="primaryCurrency"
                        v-bind:value="initvalue.primaryCurrency"
                        v-on:change="onChangeInvoice($event, 'primaryCurrency'); checkCurrency()"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Primary Currency"
                        persistent-hint
                        single-line
                        hint="Please choose the primary currency"
                      >
                      </v-select>
                      <v-select
                        v-if="type=='service'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'THB']"
                        v-model="secondaryCurrency"
                        v-bind:value="initvalue.secondaryCurrency"
                        v-on:change="onChangeInvoice($event, 'secondaryCurrency'); checkCurrency()"
                        outlined
                        dense
                        placeholder="Secondary Currency"
                        persistent-hint
                        single-line
                        hint="Please choose the secondary currency"
                      >
                      </v-select>
                      <v-text-field
                        v-if="type=='service'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="currencyRate"
                        v-bind:value="initvalue.currencyRate"
                        v-on:change="onChangeInvoice($event, 'currencyRate')"
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Currency Rate"
                        persistent-hint
                        single-line
                        hint="Enter the currency rate"
                      >
                      </v-text-field>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="paymethods.map(x => {return {text: x.paymethodname, value: x._id};})"
                        v-bind:value="initvalue.paymethodid"
                        v-on:change="onChangeInvoice($event, 'paymethodid')"
                        v-bind:error="errorindex == 8"
                        outlined
                        dense
                        placeholder="Pay Method"
                        persistent-hint
                        single-line hint="Please choose the pay method">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="properties.map(x => {return {text: x.propertyname, value: x._id};})"
                        v-bind:value="initvalue.propertyid"
                        v-on:change="onChangeInvoice($event, 'propertyid')"
                        v-bind:error="errorindex == 8"
                        outlined
                        dense
                        placeholder="Property"
                        persistent-hint
                        single-line hint="Please choose the Property">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="regions.map(x => {return {text: x.regionname, value: x._id};})"
                        v-bind:value="initvalue.regionid"
                        v-on:change="onChangeInvoice($event, 'regionid')"
                        v-bind:error="errorindex == 8"
                        outlined
                        dense
                        placeholder="Region"
                        persistent-hint
                        single-line hint="Please choose the region">
                      </v-select>
                      <v-select
                        v-if="type=='rental'"
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-bind:value="initvalue.locationid"
                        v-on:change="onChangeInvoice($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-bind:value="initvalue.refnum"
                        v-on:change="
                          onChangeInvoice($event, 'refnum')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Ref Num"
                        persistent-hint
                        single-line
                        hint="Enter the reference"
                      >
                      </v-text-field>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="invoicepayterms"
                        v-bind:value="initvalue.invoicepayterms"
                        v-on:change="onChangeInvoice($event, 'invoicepayterms')"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Pay Terms"
                        persistent-hint
                        single-line
                        hint="Please choose the pay terms"
                      >
                      </v-select>
                      <v-textarea
                          :readonly="isNotEditable"
                          v-bind:value="initvalue.invoicenote"
                          v-on:change="onChangeInvoice($event, 'invoicenote')"
                          outlined
                          dense
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/invoice/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateInvoice()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" md="6" align="right">
                    <v-btn
                      v-if="isEditable"                            
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/invoice/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="header_items"
                  :items="transactions"
                  :items-per-page="100"
                  class="elevation-0"
                >
                <template v-slot:top>
                  <v-dialog v-model="isDeleteTransaction" width="500">
                    <v-card>
                      <v-card-title> Delete this Item? </v-card-title>
                      <v-card-text>
                        {{ delete_transaction.itemdesc }}
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          outlined
                          @click="isDeleteTransaction = false"
                        >Cancel</v-btn>
                        <v-btn
                          color="secondary"
                          class="button-shadow"
                          @click="deleteTransaction(delete_transaction)"
                        >Delete</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
                <template v-slot:item.itemimage="{ item }">
                  <v-img
                    v-bind:lazy-src="item.itemimage"
                    min-width="50"
                    max-width="100"
                    v-bind:src="item.itemimage">
                  </v-img>
                </template>
                <template v-slot:item.accountid="{ item }">
                  {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountnum'] : '' }}: {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                </template>
                <template v-slot:item.itemamount="{ item }">
                  {{ item.itemamount.toFixed(2) }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    v-if="isEditable"
                    icon
                    color="primary"
                    @click="editTransactionDialog(item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="isEditable"
                    icon
                    color="primary"
                    @click="deleteTransactionDialog(item)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>{{sum_items}}</td>
                    <td>&nbsp;</td>
                  </tr>
                </template>
              </v-data-table>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/invoice/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1" align="right">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isUploadFile = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_files"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ delete_file.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(delete_file)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/invoice/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2 && account.accountsubtype=='Account').map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload_file.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload_file.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload_file.file=null; upload_file.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload_file.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import { formatCurrency } from '@/util/tools';
import router from "@/Routes";

export default {
  data() {
    return {

      header_items: [
        { text: 'Account', value: 'accountid', width: '20%' },
        { text: 'Description', value: 'itemdesc'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],
      header_files: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      
      delete_transaction: {},
      delete_file: {},
      search_customer: {},
      initvalue: {},
      new_transaction: {},
      edit_transaction: {},
      change_invoice: {},
      
      upload_file: {filename: null,file: null},
      files: [],
      branditems: [],
      invoicetype: {
        'service': ['Service Invoice'],
        'rental': ['Rental Invoice'], 
      } ,
      invoicepayterms: ['Cash', 'Credit 5 Days', 'Credit 15 Days', 'Credit 30 Days', 'Due on Receipt'],
      transactions: [],

      route: 0,
      invoice_subtotal: 0,
      invoice_total: 0,
      currencyRate: null,
      primaryCurrency: null,
      secondaryCurrency: null,

      isAddTransaction: false,
      isEditTransaction: false,
      isUploadFile: false,
      brandid: undefined,
      price: undefined,

      accountclass: null,
      accountclass2: null,
      accountsubclass: null,
      accountsubclass2: null,

      itemimage: undefined,
      itemid: undefined,
      itemname: undefined,
      itemquantity: 1,
      itemfoc: undefined,
      itemprice: undefined,
      itemamount: undefined,
      itemcategoryid: undefined,
      itemsubcategoryid: undefined,
      
      type: null,
      invoicedate: null,
      invoiceduedate: null,
      menu_invoicedate: false,
      menu_invoiceduedate: false,
      menu_etadate: false,

      isRental: false,
      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
      formatCurrency: formatCurrency,
    };
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("Item", ["items"]),
    ...mapState("Invoice", ["isReceiving"]),
    ...mapState("Location", ["locations"]),
    ...mapState("PayMethod", ["paymethods"]),
    ...mapState("Property", ["properties"]),
    ...mapState("Region", ["regions"]),
    ...mapState("User", ["users"]),
    isNotEditable(){
      let result = ['New','Sent', 'Partial','Pending','Audit','Void'].indexOf(this.initvalue.invoicestatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New', 'Sent', 'Partial', 'Audit', 'Void'].indexOf(this.initvalue.invoicestatus) >= 0;
      console.log(result);
      return result;
    },
    sum_items(){
      let result = this.transactions.reduce((a, b) => a + parseFloat(b.itemamount), 0);
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    data_classes(){
      let object = Object.groupBy(this.accounts, item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass=='Revenue');
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest", "getInvoiceFiles"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("PayMethod", ["getPayMethodsRequest"]),
    ...mapActions("Property", ["getPropertiesRequest"]),
    ...mapActions("Region", ["getRegionsRequest"]),
    ...mapActions("Invoice", ["deleteInvoiceTransactionRequest", "getInvoicesRequest", "insertInvoiceTransactionRequest", "updateInvoiceRequest", "updateInvoiceTransaction", "setQuery",]),
    ...mapActions('SystemSetting', ['getSetting']),
    ...mapActions("User", ["getUsersRequest"]),
    checkCurrency(){
      if(this.primaryCurrency==this.secondaryCurrency) {
        this.currencyRate=1;
        this.change_invoice.currencyRate=1;
      }
    },
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkError3(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc, itemquantity: item.itemquantity};
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.delete_file = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteInvoiceTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getInvoicesRequest();
    },
    async insertTransaction() {
      if(!this.checkError3()) return;
      this.new_transaction.invoiceid = this.initvalue._id;
      let response = await this.insertInvoiceTransactionRequest(this.new_transaction);
      this.transactions.push(response); 
      this.new_transaction = {};
      this.isAddTransaction = false;
    },
    editTransactionDialog(item) {
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    onChangeFile(file) {
      if (!file) this.upload_file.file = null;
      else this.upload_file.file = file;
    },
    onChangeInvoice(value, field) {
      this.change_invoice[field] = value;
    },


    searchCustomerDialog(){
      this.search_customer = {};
      this.isSearchCustomer = true;
    },
    


    async updateInvoice() {
      this.change_invoice._id = this.initvalue._id;
      await this.updateInvoiceRequest(this.change_invoice);
      router.push("/invoice/list");
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateInvoiceTransaction(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getInvoicesRequest();
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload_file.id = this.initvalue._id;
      this.upload_file.route = 'invoice';
      let file = await this.insertRouteFile(this.upload_file);
      this.files.push(file);
      this.upload_file = {filename: null,file: null};
    },
  },

  async created() {
    this.initvalue = this.$route.params;

    if(!this.initvalue._id) this.$router.push({ name: "InvoiceList" });
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.paymethods.length==0) await this.getPayMethodsRequest();
    if(this.properties.length==0) await this.getPropertiesRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.users.length==0) await this.getUsersRequest();

    this.files = this.initvalue.files;
    this.transactions = this.initvalue.transactions;

    this.invoicedate = formatStdDate(this.initvalue.invoicedate);
    this.invoiceduedate = formatStdDate(this.initvalue.invoiceduedate);
    this.currencyRate = this.initvalue.currencyRate;
    this.primaryCurrency = this.initvalue.primaryCurrency;
    this.secondaryCurrency = this.initvalue.secondaryCurrency;

    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
